import { render } from "./HighLevelTalentPanel.vue?vue&type=template&id=16bb3580&scoped=true"
import script from "./HighLevelTalentPanel.vue?vue&type=script&lang=js"
export * from "./HighLevelTalentPanel.vue?vue&type=script&lang=js"

import "./HighLevelTalentPanel.vue?vue&type=style&index=0&id=16bb3580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bb3580"]])

export default __exports__